import React,  { useState, useEffect } from "react";
import { storage } from "firebase";
// import { isEmpty} from "lodash";
import { Redirect } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import * as firebase from "firebase";
import { Layout, Row, Col, Card, message, Modal } from "antd";
import {
  addAppThemConfig,
  getAppThemConfig,
  deleteAppThemConfig
} from "../Database/firebase";

import Header from "../Components/Header";
import AppConfigDetailsForm from "../Components/AppConfigDetailsForm";
import AppThemConfigTable from "../Components/AppThemConfigTable";

const { Content } = Layout;

const AppThemConfigPage = () => {
  const [loggedIn, setLoggedIn] = useState(null);
  const [user, setUser] = useState(null);
  const [imageAsFile, setImageAsFile] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [headerBgColor, setHeaderBgColor]= useState("");
  const [appThemConfigCollection, setAppThemConfigCollection] = useState([]);

  useEffect(() => {
    let user = localStorage.getItem("User");

    getAppThemConfig.then((snap) => {
      let temp = [];
      snap.forEach((doc) => {
        if (doc.data()) temp.push({ ...{ id: doc.id }, ...doc.data() });;
      });
      setAppThemConfigCollection(temp);
    })

    if (user) {
      setLoggedIn(true);
      setUser(JSON.parse(user));
    } else {
      setLoggedIn(false);
    }
  }, []);

  const onFileUpload = (e) => {
    setImageAsFile(e.file);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const logout = () => {
    firebase
      .auth()
      .signOut()
      .then(function () {
        // Sign-out successful.
        localStorage.clear();
        setLoggedIn(false);
      })
      .catch(function (error) {
        // An error happened.
        console.error(error);
      });
  };

  const addNewAppThimConfig = () => {
    const newAppThemConfig = {
      headerBgColor: headerBgColor,
      headerIcon: imageUrl ? imageUrl : localStorage.getItem("uploadedAppThemImageUrl"),
    };
    addAppThemConfig(newAppThemConfig).then((doc) => {
      localStorage.setItem("uploadedAppThemImageUrl", "");
      const temp = [...appThemConfigCollection];
      newAppThemConfig.id = doc.id;
      temp.push(newAppThemConfig);
      setAppThemConfigCollection(temp);
      setLoading(false);
      resetFields();
      message.info("App Them Config Added!");
    })
    .catch(error => {
      setLoading(false);
      console.error(error);
    })
  };

  const getChildByRefName = (childName, refName) => {
    return new Promise((resolutionFunc, rejectionFunc) => {
      storage()
        .ref(refName)
        .child(childName)
        .getDownloadURL()
        .then((fireBaseUrl) => {
          console.log(`================== fireBaseUrl ${refName}`, fireBaseUrl);
          setImageUrl(fireBaseUrl);
          localStorage.setItem("uploadedAppThemImageUrl", fireBaseUrl);
          setImageAsFile(null);
          resolutionFunc(true);
        })
        .catch((err) => {
          console.log("ERR getDownloadURL", err.message);
        });
    });
  };

  const imageUpload = (imageName) => {
    return new Promise((resolutionFunc, rejectionFunc) => {
      const uploadTask = storage()
        .ref(`/app_them_config_images/${imageName}`)
        .put(imageAsFile.originFileObj);
      uploadTask.on(
        "state_changed",
        (snapShot) => {
          console.log(snapShot);
        },
        (err) => {
          console.log("ERR uploadTask", err);
        },
        () => {
          getChildByRefName(imageName, "app_them_config_images").then(() => {
            addNewAppThimConfig(imageName);
            resolutionFunc(true);
          });
        }
      );
    });
  };

  const handleFireBaseUpload = async () => {
    const imageName = uuidv4();
    setLoading(true);
    if (imageAsFile) {
      imageUpload(imageName);
    } else {
      addNewAppThimConfig();
    }
  };

  const onSubmit = () => {
    handleFireBaseUpload();
  }
  
  const resetFields = () => {
    setImageAsFile(null);
    setHeaderBgColor("");
    setImageUrl("");
  }

  const deleteRecord = (record) => {
    deleteAppThemConfig(record.id)
    .then((res) => {
      message.success("Record deleted !!!");
      setAppThemConfigCollection([]);
    })
    .catch(error => {
      console.error(error);
      message.error(error.message)
    })
  }
  
  if (loggedIn === null) return <div />;
  if (loggedIn === false) return <Redirect to={"/"} />;

  return (
    <div className="election-page">
      <Layout className="layout" style={{ background: "#1f2228" }}>
        <Header logout={logout} componentName="LatestArticlePage" />
        <Content style={{ padding: "0 10px", background: "#1f2228" }}>
          <div className="site-layout-content">
            <Row>
              <Col span={24}>
                <Card style={{ borderRadius: "15px" }}>
                  <AppConfigDetailsForm
                     file={imageAsFile}
                     setHeaderBgColor={setHeaderBgColor}
                     onSubmit={onSubmit}
                     onFileUpload={onFileUpload}
                     appThemConfigCollection={appThemConfigCollection}
                     headerBgColor={headerBgColor}
                  />
                </Card>
              </Col>
            </Row>
            <Row>
              <Col flex={2}>
                <Card style={{ marginTop: 10, borderRadius: "15px" }}>
                  <AppThemConfigTable 
                    loading={loading}
                    AppThemData={appThemConfigCollection}
                    deleteRecord={deleteRecord}
                  />
                </Card>
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
    </div>
  )
}

export default AppThemConfigPage;